export const toClassName = (...values: (boolean | string | undefined)[]) => {
  return values.filter(Boolean).join(' ');
};

export const handleGenerateInitialsFromName = (name: string) => {
  let result = name;

  if (name) {
    result = name.charAt(0);
  }

  return result;
};

export const handleFormatDate = (date: string, t: any) => {
  const dateObject = new Date(date);
  return `${dateObject.getDate()} ${t(`enum.date.month.${dateObject.getMonth()}`)} ${dateObject.getFullYear()}`;
};

export const handleConvertToLocale = (lang: string) => {
  let result = lang;

  switch (lang) {
    case 'nl':
      result = 'nl-BE';
      break;
    case 'fr':
      result = 'fr-BE';
      break;
    case 'en':
      result = 'en';
      break;
  }

  return result;
};
